import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { RefreshCw, Check, Repeat2 } from 'lucide-react';
import { VideoFeatures } from '@/store/videoFeatures/types';
import { HeroCard } from '@/components/ui/HeroCard';

interface RestartAfterEndConfigProps {
  features: VideoFeatures;
  setFeature: <K extends keyof VideoFeatures>(key: K, value: VideoFeatures[K]) => void;
}

export const RestartAfterEndConfig: React.FC<RestartAfterEndConfigProps> = ({ features, setFeature }) => {
  useLanguage();
  const enabled = features.haveRestart ?? false;

  const handleToggle = (value: boolean) => {
    setFeature('haveRestart', value);
  };

  return (
    <div className="space-y-3 p-4">
      <HeroCard
        icon={<RefreshCw className="w-full h-full" strokeWidth={2} />}
        title={translateInterfaceText("Recomeçar após finalizar")}
        description={translateInterfaceText("Defina se o vídeo deve voltar ao início automaticamente quando a reprodução terminar.")}
        isActive={enabled}
        onToggle={handleToggle}
      />

      <p className="text-[11px] text-[#9CA3AF] px-1">
        {translateInterfaceText("Funciona ao final da reprodução do vídeo.")}</p>

      <div className="rounded-[16px] border border-[#E4E7EC] bg-white p-7 flex flex-col items-center text-center">
        <div
          className={`w-11 h-11 rounded-[12px] flex items-center justify-center mb-4 ${
            enabled ? 'bg-[#EEF4FF] text-[#1D4FFF]' : 'bg-[#F3F4F6] text-[#9CA3AF]'
          }`}
        >
          <Repeat2 className="w-[22px] h-[22px]" strokeWidth={2} />
        </div>

        <div className="flex items-center gap-2 mb-2">
          <h3 className="text-[15px] font-semibold text-[#1A1A1A] leading-tight">
            {enabled ? translateInterfaceText("Reinício automático ativado") : translateInterfaceText("Reinício automático desativado")}
          </h3>
        </div>

        <p className="text-[13px] text-[#6B7280] leading-relaxed max-w-[280px]">
          {enabled
            ? translateInterfaceText("Ao finalizar, o vídeo volta ao início automaticamente, mantendo a reprodução em loop.")
            : translateInterfaceText("Ative o recurso acima para reiniciar o vídeo automaticamente ao chegar ao fim.")}
        </p>
      </div>
    </div>
  );
};
